import {
  Box,
  Card,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { SelectedAddon } from './AddonSelector';

interface SelectedAddonsListProps {
  addons: SelectedAddon[];
  onRemove: (id: string) => void;
  onQuantityChange: (id: string, newQty: number) => void;
}

const SelectedAddonsList: React.FC<SelectedAddonsListProps> = ({
  addons,
  onRemove,
  onQuantityChange,
}) => {
  const totalAmount = addons.reduce((sum, addon) => sum + addon.unitPrice, 0);

  if (addons.length === 0) {
    return null; // Don't show anything if no addons
  }

  return (
    <Card sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant='h6'>
          Selected Addons ({addons.length})
        </Typography>
        <Typography variant='h6' color='primary'>
          Total: {totalAmount.toFixed(2)} QAR
        </Typography>
      </Box>

      <TableContainer
        sx={{
          maxHeight: 400,
          overflowX: 'auto',
          overflowY: 'auto',
        }}
      >
        <Table size='small' stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell align='center'>Qty</TableCell>
              <TableCell align='right'>Unit Price</TableCell>
              <TableCell align='right'>Total</TableCell>
              <TableCell align='center'>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {addons.map((addon, index) => (
              <TableRow key={addon.id} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <Typography variant='body2'>{addon.labelEn}</Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {addon.labelAr}
                  </Typography>
                </TableCell>
                <TableCell align='center'>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                    <IconButton
                      size='small'
                      onClick={() => onQuantityChange(addon.id, Math.max(1, addon.qty - 1))}
                      disabled={addon.qty <= 1}
                    >
                      <RemoveIcon fontSize='small' />
                    </IconButton>
                    <Typography variant='body2' sx={{ minWidth: 30, textAlign: 'center' }}>
                      {addon.qty}
                    </Typography>
                    <IconButton
                      size='small'
                      onClick={() => onQuantityChange(addon.id, addon.qty + 1)}
                    >
                      <AddIcon fontSize='small' />
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell align='right'>{addon.price.toFixed(2)} QAR</TableCell>
                <TableCell align='right'>
                  <Typography variant='body2' fontWeight='bold'>
                    {addon.unitPrice.toFixed(2)} QAR
                  </Typography>
                </TableCell>
                <TableCell align='center'>
                  <IconButton
                    size='small'
                    color='error'
                    onClick={() => onRemove(addon.id)}
                  >
                    <DeleteIcon fontSize='small' />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Card>
  );
};

export default SelectedAddonsList;

